import { useState } from 'react';
import clsx from 'clsx';
import styles from './TechWork.module.scss';
import { Container } from '../../Container/Container';
import { CrossIcon } from '../../Icons/Cross';
import Warning from '../../Icons/Warning';

const TechWork = () => {
  const [close, setClose] = useState(false);
  return (
    <div className={clsx(styles.TechWork, { [styles.close]: close })}>
      <Container>
        <div className={styles.holder}>
          <div className={styles.text_holder}>
            <Warning />
            <p>
              Мы обновляем сайт. В ближайшее время возможны ошибки в работе
              сервиса. Спасибо за терпение.
            </p>
          </div>
          <button onClick={() => setClose(true)}>
            <CrossIcon />
          </button>
        </div>
      </Container>
    </div>
  );
};

export default TechWork;
